import { format } from 'date-fns'

import AnalogClock from '../components/AnalogClock'
import { signIn } from '../lib/auth'

export default function SignIn() {
  const now = new Date()
  return (
    <div className="h-full grid place-items-center bg-canvas p-8">
      <div className="max-w-sm w-full card p-8">
        <div className="h-eyebrow mb-2">PlusTag</div>
        <h1 className="text-2xl font-semibold tracking-tight mb-6">Workspace</h1>

        <div className="card-inset p-4 mb-6 flex items-center gap-4">
          <AnalogClock size={80} />
          <div>
            <div className="text-xl font-semibold text-ink-900">{format(now, 'h:mmaaa')}</div>
            <div className="text-xs text-ink-500 mt-0.5">{format(now, 'EEE, do MMMM')}</div>
          </div>
        </div>

        <p className="text-sm text-ink-500 mb-6 leading-relaxed">
          Mail &amp; calendar hosted natively on <span className="font-mono text-ink-700">plustag.email</span>.
        </p>
        <button
          onClick={signIn}
          className="w-full pill-primary justify-center py-2.5 text-sm"
        >
          Sign in with PlusTag
        </button>
      </div>
    </div>
  )
}
